/**
 * Function to register callbacks against Websocket
 *
 * @param {socket} socket Websocket connection object
 * @param {Vuex} store Application Vuex store
 * @param {auth} auth Authentication object
 */
export default function(socket, store, auth) {
  const callbacks = [];

  /**
   * Register a callback for specific message type
   *
   * @param {string} type Message type that callback should execute for
   * @param {Function} cb Callback that should be executed
   */
  function registerCallback(type, cb) {
    callbacks.push({ type, cb });
  }

  socket.addMessageCallback((msg) => {
    callbacks.filter((cb) => cb.type === msg.type)
      .forEach((cb) => cb.cb(msg.content));
  });

  registerCallback('NEW_JWT_AVAILABLE', () => auth.refresh());

  registerCallback('ACCESS_REQUEST_CREATED', (request) => {
    store.dispatch('alert/showCard', {
      message: `New access request from ${request.user.name} to access ${request.summary}`,
      link: {
        label: 'View request',
        href: `/approvals/requests/${request.user.aoid}/${request.createdTs}`
      }
    });
  });

  registerCallback('ACCESS_REQUEST_CLOSED', (request) => {
    store.dispatch('alert/showCard', {
      message: 'Access request has been ' +
        request.status.toLowerCase() +
        ' by ' + request.closedBy.name,
      link: {
        label: 'View request',
        href: `/approvals/requests/${request.user.aoid}/${request.createdTs}`
      }
    });
  });
}
